export default {"src":"/_next/static/media/arrow-left.fc840d3d.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};